import { render, staticRenderFns } from "./CompuAppointmentSummary.vue?vue&type=template&id=5b29dc8a&scoped=true&"
import script from "./CompuAppointmentSummary.vue?vue&type=script&lang=js&"
export * from "./CompuAppointmentSummary.vue?vue&type=script&lang=js&"
import style0 from "./CompuAppointmentSummary.vue?vue&type=style&index=0&id=5b29dc8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b29dc8a",
  null
  
)

export default component.exports